module.exports = __webpack_public_path__ + "static/media/instagram.b8e913e5.svg";